/**
 * Request and response shaping shared by the two driving-route services
 * (MapboxService and OsrmRouteService). Both speak the OSRM route API shape:
 * `lon,lat;lon,lat` in the path, `routes[0]` with metres, seconds and a
 * GeoJSON line out.
 */

/** Ask for the full route line as GeoJSON. */
export const ROUTE_PARAMS = { geometries: 'geojson', overview: 'full' };

/** `{lat, lon}` points as the `lon,lat;lon,lat` path segment (lon first). */
export const toLonLatPath = (points) => points
  .map((point) => `${point.lon},${point.lat}`)
  .join(';');

/** One route as `{ distance (km, 1 decimal), duration (min), geometry (GeoJSON LineString) }`. */
export const toRouteResult = (route) => ({
  distance: Math.round(route.distance / 100) / 10,
  duration: Math.round(route.duration / 60),
  geometry: route.geometry,
});
